import {
  requestJson,
} from '../../../shared/api/apiClient';

const PRODUCT_MACHINE_COUNTS_ENDPOINT =
  '/api/licenses/product-machine-counts';

const SITE_TERM_ENDPOINT =
  '/api/licenses/site/term';

const HI_LINK_TERM_ENDPOINT =
  '/api/licenses/hi-link/term';

const TMS_PER_MACHINE_ENDPOINT =
  '/api/licenses/tms/per-machine';

function extractData(response) {
  if (
    response &&
    typeof response === 'object' &&
    response.data !== undefined
  ) {
    return response.data;
  }

  return null;
}

export async function getProductMachineCounts() {
  const response = await requestJson(
    PRODUCT_MACHINE_COUNTS_ENDPOINT,
    {
      method: 'GET',
    },
  );

  const data = extractData(response);
  return Array.isArray(data) ? data : [];
}

export async function getHiLinkTermLicense() {
  const response = await requestJson(
    HI_LINK_TERM_ENDPOINT,
    {
      method: 'GET',
    },
  );

  return extractData(response);
}

export async function getSiteTermLicense() {
  const response = await requestJson(
    SITE_TERM_ENDPOINT,
    {
      method: 'GET',
    },
  );

  return extractData(response);
}

export async function getTmsPerMachineLicenses() {
  const response = await requestJson(
    TMS_PER_MACHINE_ENDPOINT,
    {
      method: 'GET',
    },
  );

  return extractData(response);
}

export async function getLicenseBundle() {
  const [
    machineCounts,
    siteTerm,
    hiLink,
    tms,
  ] = await Promise.all([
    getProductMachineCounts(),
    getSiteTermLicense(),
    getHiLinkTermLicense(),
    getTmsPerMachineLicenses(),
  ]);

  return {
    machineCounts,
    siteTerm,
    hiLink,
    tms,
  };
}
